import { ContactSupportId } from 'src/constants/constants';

export const getErrorMessage = (error: any): string => {
  const errorData = error?.response?.data?.errors;
  const errorMessage =
    errorData?.[0]?.message ??
    `We are having some trouble, Please contact support for help. id: ${ContactSupportId.complianceHelpers}`;

  return errorMessage;
};
